/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PortalPreview } from './PortalPreview';
import {
    PortalPreviewFromJSON,
    PortalPreviewFromJSONTyped,
    PortalPreviewToJSON,
    PortalPreviewToJSONTyped,
} from './PortalPreview';

/**
 * 
 * @export
 * @interface PortalPreviewResponse
 */
export interface PortalPreviewResponse {
    /**
     * 
     */
    data: PortalPreview;
}

/**
 * Check if a given object implements the PortalPreviewResponse interface.
 */
export function instanceOfPortalPreviewResponse(value: object): value is PortalPreviewResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function PortalPreviewResponseFromJSON(json: any): PortalPreviewResponse {
    return PortalPreviewResponseFromJSONTyped(json, false);
}

export function PortalPreviewResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortalPreviewResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': PortalPreviewFromJSON(json['data']),
    };
}

export function PortalPreviewResponseToJSON(json: any): PortalPreviewResponse {
    return PortalPreviewResponseToJSONTyped(json, false);
}

export function PortalPreviewResponseToJSONTyped(value?: PortalPreviewResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': PortalPreviewToJSON(value['data']),
    };
}

